import { render, staticRenderFns } from "./compact-customer-summary.vue?vue&type=template&id=d9959c7a&"
import script from "./compact-customer-summary.vue?vue&type=script&lang=js&"
export * from "./compact-customer-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports